const theme = {
    sizes: {
        header: 5,
    },
    colors: {
        white: 'white',
        lightGrey: '#e8e8e8',
    },
    imageMap: {
        margin: 0.5,
    },
};

export default theme;
